module.exports = __webpack_public_path__ + "fonts/sf-regular.aaeac71d.otf";